import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import divide from 'notebook/tables/excess/util/divide';

export default {
  name: 'MOD',
  category: FunctionCategory.MATH,
  shortDescription: 'Modulo (remainder) operation.',
  description: 'Returns the result of the modulo operator, the remainder after a division operation.',
  params: [
    {
      name: 'dividend',
      type: ArgType.number,
      description: 'The number to be divided to find the remainder.',
    },
    {
      name: 'divisor',
      type: ArgType.number,
      description: 'The number to divide by.',
    },
  ],
  eval: (dividend: number, divisor: number): number => {
    divide(dividend, divisor, 'MOD'); // test for divide by 0
    return __mod__(dividend, divisor);
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;

function __mod__(a: number, b: number): number {
  a = Number(a);
  b = Number(b);
  return ((a % b) + b) % b;
}
